export const NoCon = ({col = 1}) => {
    return (
        <tr>
            <td colSpan={col}>
                <div className="gs-no-con">등록된 내용이 없습니다.</div>
            </td>
        </tr>
    )
}